import { connect } from 'react-redux'
import Register from '../../components/authentication/Register'
import { userRegister } from '../../state/actions/auth/index'
import { IStoreState, IUserRegisterFormData } from '../../types/index'

export function mapStateToProps(state: IStoreState) {
  return {
    isFetching: state.authorization.isFetching,
    isFetchSuccess: state.authorization.isFetchSuccess,
    error: state.authorization.error
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    registerUser: (data: IUserRegisterFormData, { setSubmitting }: any) =>
      dispatch(userRegister(data, { setSubmitting }))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Register)



// WEBPACK FOOTER //
// ./src/containers/auth/Register.ts